var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg01Titel = function Svg01Titel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21 86.9h138.68v18.91H5.21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 86.5h140.71v19.72H4.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.3 110.57H5.3c-2.92 0-5.3-2.37-5.3-5.3V65.46c0-2.92 2.37-5.3 5.3-5.3h138c2.92 0 5.3 2.37 5.3 5.3v39.81c0 2.93-2.37 5.3-5.3 5.3zM10.6 99.98h127.41V70.76H10.6v29.22zM5.21 143h189.51v18.91H5.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82 142.6H196.1v19.72H3.82z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.7 168.95H5.3c-2.92 0-5.3-2.37-5.3-5.3v-39.81c0-2.92 2.37-5.3 5.3-5.3h189.4c2.92 0 5.3 2.37 5.3 5.3v39.81c0 2.93-2.37 5.3-5.3 5.3zM10.6 158.36h178.81v-29.22H10.6v29.22zM78.45 41.64H5.3c-2.92 0-5.3-2.37-5.3-5.3 0-2.92 2.37-5.3 5.3-5.3h73.16c2.92 0 5.3 2.37 5.3 5.3a5.311 5.311 0 0 1-5.31 5.3z"
  })));
};
export default Svg01Titel;